'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getToggleStyleFunc;

var _draftJs = require('draft-js');

function getToggleStyleFunc(callbacks) {
    return function toggleStyle(styleName) {
        var getEditorState = callbacks.getEditorState;
        var setEditorState = callbacks.setEditorState;

        var editorState = getEditorState();
        var selection = editorState.getSelection();
        setEditorState(_draftJs.RichUtils.toggleInlineStyle(getEditorState(), styleName));
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-utils@0.1.0@rc-editor-utils/lib/getToggleStyleFunc.js
// module id = 115
// module chunks = 0 1 2